/**
 * Auditoria
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationRequired,
} from 'simpli-web-sdk'
import AuditoriaMotivo from '@/model/resource/AuditoriaMotivo'
import Responsavel from '@/model/resource/Responsavel'
import Carga from '@/model/resource/Carga'
import AuditoriaSchema from '@/schema/Auditoria.schema'
import AuditoriaObservacao from '@/model/resource/AuditoriaObservacao'
import EmailAuditoria from '@/model/resource/EmailAuditoria'
import ResponsavelUsuario from '@/model/resource/ResponsavelUsuario'
import Administrador from '@/model/resource/Administrador'

export default class Auditoria extends Resource {
  readonly $name: string = 'Auditoria'

  readonly $endpoint: string = '/user/carga/{id}/auditoria'

  get $schema() {
    return AuditoriaSchema(this)
  }

  get $id() {
    return this.idAuditoriaPk
  }
  set $id(val: ID) {
    this.idAuditoriaPk = val
  }

  @ResponseSerialize(EmailAuditoria)
  emailAuditoria: EmailAuditoria | null = null

  @ResponseSerialize(AuditoriaMotivo)
  motivo: AuditoriaMotivo | null = null

  responsavelUsuario: ResponsavelUsuario | null = null

  administrador: Administrador | null = null

  @ResponseSerialize(AuditoriaObservacao)
  observacao = new AuditoriaObservacao()

  @ResponseSerialize(AuditoriaObservacao)
  observacoes: AuditoriaObservacao[] = []

  @ResponseSerialize(Responsavel)
  responsavel = new Responsavel()

  idAuditoriaPk: ID = 0

  @ValidationRequired()
  conforme: boolean | null = null

  dataCanhoto: string | null = null

  dataCriacao: string | null = null

  replicarCTE: boolean | null = null

  get observacoesAsText() {
    let str = ''
    if (this.observacoes) {
      this.observacoes.forEach((obs) => {
        const resp = obs.responsavel && (obs.responsavel.nomeFantasia || obs.responsavel.cnpj)
        const text = obs.texto
        str += `${resp}: ${text}; `
      })
    }
    return str
  }

  get conformeTagClass() {
    if (this.conforme === true) {
      return 'green-dark'
    } else if (this.conforme === false) {
      return 'danger'
    }
    return 'default'
  }

  get conformeTranslated() {
    if (this.conforme === true) {
      return $.t('classes.Auditoria.columns.approved')
    } else if (this.conforme === false) {
      return $.t('classes.Auditoria.columns.decline')
    }
    return null
  }

  get idResponsavelFk() {
    if (!this.responsavel) return 0
    return this.responsavel.$id
  }
  set idResponsavelFk(idResponsavelFk: ID) {
    if (!this.responsavel) this.responsavel = new Responsavel()
    this.responsavel.$id = idResponsavelFk
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(idCargaFk: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.idCargaPk = idCargaFk
  }

  carga: Carga | null = null

  get idMotivoFk() {
    if (!this.motivo) return 0
    return this.motivo.$id
  }
  set idMotivoFk(idMotivoFk: ID) {
    if (!this.motivo) this.motivo = new AuditoriaMotivo()
    this.motivo.idMotivoPk = idMotivoFk
  }

  get isEmpty(): Boolean {
    return this.$id === 0
  }

  async changeDataCanhoto(model: Auditoria, spinner = 'persistAuditoria') {
    const fetch = async () => {
      return await this.POST(`/user/carga/${model.idCargaFk}/auditoria/dataCanhoto`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async persistAuditoria(model: Auditoria, spinner = 'persistAuditoria') {
    const fetch = async () => {
      await model.validate()
      return await this.POST(`/user/carga/${model.idCargaFk}/auditoria`, model)
    }

    return await $.await.run(fetch, spinner)
  }
}
